<template>
  <el-dialog
    class="radish-dia"
    title="拖拽排序"
    top="70px"
    :width="hasReset ? '300px' : '200px'"
    :modal="false"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <SortableList v-model="items" lock-axis="y">
      <SortableItem v-for="(item, index) in items" :key="index" :index="index" :item="item" />
    </SortableList>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" v-if="hasReset" @click="handleReset">恢复默认</el-button>
      <el-button size="mini" @click="dialogVisible = false">关闭</el-button>
      <el-button size="mini" type="primary" @click="handleConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { ContainerMixin, ElementMixin } from 'vue-slicksort'

const SortableList = {
  mixins: [ContainerMixin],
  render: function(createElement) {
    return createElement('div', { attrs: { class: 'sortlist' } }, this.$slots.default)
  },
}
const SortableItem = {
  mixins: [ElementMixin],
  props: ['item'],
  render: function(createElement) {
    return createElement('div', { attrs: { class: 'sortlist-item' } }, this.item)
  },
}
export default {
  components: {
    SortableItem,
    SortableList,
  },
  data: function() {
    return {
      dialogVisible: false,
      items: [],
      storageName: '',
      hasReset: false,
      onConfirm: function() {},
      onReset: function() {},
    }
  },
  methods: {
    show: function(param) {
      const { items, storageName, onConfirm, hasReset, onReset } = param
      this.items = items
      this.storageName = storageName
      if (onConfirm) {
        this.onConfirm = onConfirm
      }
      if (hasReset) {
        this.hasReset = hasReset
      }
      if (onReset) {
        this.onReset = onReset
      }
      this.dialogVisible = true
    },
    handleConfirm: function() {
      let dt = {}
      this.items.forEach((h, k) => {
        dt[h] = k + 1
      })
      dt = JSON.stringify(dt)
      localStorage[`${this.storageName}_sort`] = dt
      this.onConfirm()
      this.dialogVisible = false
    },
    handleReset: function() {
      localStorage[`${this.storageName}_sort`] = ''
      this.onReset()
      this.dialogVisible = false
    },
  },
}
</script>
<style>
.sortlist {
  background-color: #f3f3f3;
  border: 1px solid #efefef;
  max-height: 60vh;
  overflow-y: auto;
}
.sortlist-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 100%;
  padding: 10px 20px;
  background-color: #fff;
  border-bottom: 1px solid #efefef;
  box-sizing: border-box;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  color: #333;
  font-weight: 400;
  cursor: pointer;
  z-index: 9999;
}
</style>
